import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import CustomDropdown from 'Components/CustomDropdown'
import Button from 'Components/UIComponent/Button'
import weather1 from '../../Assets/lottie/weather_anim.json'
import weather2 from '../../Assets/lottie/weather_partially_shower.json'
import weather3 from '../../Assets/lottie/weather_sunny.json'
import weather4 from '../../Assets/lottie/weather_snow.json'
import weather5 from '../../Assets/lottie/weather_thunder.json'
import weather6 from '../../Assets/lottie/weather_rainy.json'
import weather7 from '../../Assets/lottie/weather_snow_sunny.json'

const Weather = () => {
  const weatherAnimations = [weather1, weather2, weather3, weather4, weather5, weather6, weather7]
  const { t } = useTranslation()

  const { setLoading } = useContext(CoffeeWebContext)
  const [countryList, setCountryList] = useState([])
  const [selectedCountry, setSelectedCountry] = useState({})
  const [selectedAnimation, setSelectedAnimation] = useState(null)

  useEffect(() => {
    fetchAllCountries()
  }, [])

  const fetchAllCountries = async () => {
    setLoading(true)

    try {
      const response = await apiAdapterCoffeeWeb.getAllCountries()

      const coffeeProducingCountries = response?.data
        ?.filter((item) => item?.isCoffeeProducingCountry)
        ?.map((ele) => ({
          ...ele,
          flag: ele.flagsUrl,
          id: ele.id.toString(),
          name: ele.nicename
        }))
        ?.sort((a, b) => a.coffeeProducingOrderBy - b.coffeeProducingOrderBy)

      const randomIndex = Math.floor(Math.random() * weatherAnimations.length)

      setCountryList(coffeeProducingCountries)
      setSelectedCountry(coffeeProducingCountries?.[0])
      setSelectedAnimation(weatherAnimations[randomIndex])
    } catch (error) {
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleCountryChange = (event) => {
    const chosenCountry = event.target.value

    setSelectedCountry(chosenCountry)
    const randomIndex = Math.floor(Math.random() * weatherAnimations.length)

    setSelectedAnimation(weatherAnimations[randomIndex])
  }

  return (
    <div className="weather-container">
      <div className="weather-header">
        <div className="title">{t('COFFEE_WEATHER')}</div>
        <div className="dropdown-wrapper">
          <Button buttonType={'CUSTOM'} buttonLabel={t('OTHER_LOCATIONS')} variant={'hard-action'} />
          <CustomDropdown value={selectedCountry} options={countryList} optionLabel={'nicename'} onChange={handleCountryChange} showFlags={true} filter={true} dropdownErrorMessage={t('COUNTRY_LIST_DATA_NOT_AVAILABLE')} placeholder={t('SELECT_COUNTRY')} className="weather-dropdown" panelClassName="coffee-weather-panel" />
        </div>
      </div>

      {selectedAnimation && (
        <div className="weather-animation-wrapper">
          <div className="coming-soon-title">
            <h1>{t('WEATHER_COMING_SOON')}</h1>
          </div>
          <Lottie animationData={selectedAnimation} loop={true} className="weather-animation" />
        </div>
      )}
    </div>
  )
}

export default Weather
